export default "__VITE_PUBLIC_ASSET__9087d894__"